import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Alert from "../../components/Alert";
import { Link } from "react-router-dom";
import { loadAccounts, loadJournalVoucher } from "../../redux/actions/tally";
import ServerPaginationTable from "../../components/ServerPaginationTable";
import SyncStatus from "../../components/SyncStatus";
import { migrateTallyJournalData, migrateJEToTally } from "../../api/index";
import SyncRemarkRender from "../../components/SyncRemarkRender";

const columns = [
  {
    Header: "Voucher ID",
    accessor: "cartJournalId",
  },
  {
    Header: "Voucher Number",
    accessor: "cartJournalSequenceCode",
  },
  {
    Header: "Voucher Date",
    accessor: "journalDate",
  },
  {
    Header: "Deskera ID",
    accessor: "deskeraId",
  },
  {
    Header: "Deskera Sequence Code",
    accessor: "deskeraDocumentSequenceCode",
  },
  {
    Header: "Sync Status",
    accessor: "syncStatus",
    Cell: ({ cell: { row } }) => {
      return (
        <SyncStatus
          status={row.original.syncStatus}
          reason={row.original.reason}
          id={row.original.cartProductId}
        />
      );
    },
  },
  {
    Header: "Sync Remarks",
    accessor: "reason",
    disableSortBy: true,
    Cell: ({ cell: { row } }) => {
      let value =
        row.original?.syncStatus !== "SUCCESSFUL" && row.original?.reason
          ? row.original?.reason
          : "";
      return <SyncRemarkRender value={value} id={row.original.id.toString()} />;
    },
  },
];

function JournalVoucher() {
  const tallyConfig = useSelector((state) => state.tally.accounts);
  const journalVouchersData = useSelector((state) => {
    return state.tally.journalVouchers;
  });
  const dispatch = useDispatch();
  const [pageCount, setPageCount] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(loadAccounts());
    dispatch(loadJournalVoucher());
  }, []);

  const data = useMemo(() => journalVouchersData.data, [journalVouchersData]);

  useEffect(() => {
    setLoading(false);
    if (journalVouchersData && journalVouchersData?.data?.totalPages) {
      setPageCount(journalVouchersData?.data?.totalPages);
    }
  }, [journalVouchersData]);

  const refreshData = ({ pageSize, pageIndex, status, sortBy, search }) => {
    setLoading(true);
    dispatch(
      loadJournalVoucher(pageSize, pageIndex, status, sortBy, search ?? "")
    );
  };

  return (
    <>
      <div className='p-4'>
        <h3 className='mb-3'>Journal Voucher</h3>
        {(!tallyConfig.data || !tallyConfig.data.syncEnable) && (
          <Alert type='warning'>
            Your synced Journal Vouchers will appear here. Please complete{" "}
            <Link to='/app/tally' className='text-alert-warning'>
              <u>Setup</u>
            </Link>{" "}
            before continuing.
          </Alert>
        )}
        <ServerPaginationTable
          data={data?.content ? data.content : []}
          columns={columns}
          cart='tally'
          refresh={refreshData}
          migrate={migrateTallyJournalData}
          syncToTally={migrateJEToTally}
          tab='Journal'
          pageCount={pageCount}
          loading={loading}
          rowId='id'
        />
      </div>
    </>
  );
}

export default JournalVoucher;
